module.exports = __webpack_public_path__ + "img/h4.702b7237.jpg";